<template>
  <v-container fluid v-if="returnOrder && !loadingReturnSetting">
    <v-card outlined>
      <v-container fluid>
        <return-headers-mobile :returnOrder="returnOrder" v-if="isMobile" />
        <return-headers :returnOrder="returnOrder" v-else />
        <v-toolbar flat v-if="isScanStep">
          <v-list-item-action-text v-if="isMobile">{{ $t('return.receiveProductsMobile') }}:</v-list-item-action-text>
          <v-card-text v-else class="subtitle">{{ $t('return.receiveProducts') }}:</v-card-text>
          <v-spacer></v-spacer>
          <v-btn outlined fab small right @click="openBarcodeDialog" class="mr-1">
            <v-icon>mdi-barcode</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar
          flat
          color="white"
          v-else-if="['products_received', 'products_partially_received'].includes(returnOrder.current_status)"
        >
          <span v-if="['products_received', 'products_partially_received'].includes(returnOrder.current_status)">
            <v-list-item-action-text v-if="isMobile">{{ $t('return.refundProductsMobile') }}:</v-list-item-action-text>
            <v-card-text v-else class="subtitle">{{ $t('return.refundProducts') }}:</v-card-text>
          </span>
        </v-toolbar>
        <v-divider></v-divider>
        <!-- list display mobile-->
        <product-list-mobile
          v-if="isMobile"
          :items="returnOrder.items"
          :currency="returnOrder.currency"
          :returnStatus="returnOrder.current_status"
          :itemNonRefundReasons="itemNonRefundReasons"
        />
        <!-- list display -->
        <product-list
          v-else
          :items="returnOrder.items"
          :currency="returnOrder.currency"
          :returnStatus="returnOrder.current_status"
          :itemNonRefundReasons="itemNonRefundReasons"
        />

        <v-col
          v-if="
            ['products_received', 'products_partially_received'].includes(returnOrder.current_status) &&
            refundCarrierCost.display_refund_button &&
            !transportAlreadyRefundedInAnotherReturn &&
            totalSelectedProducts
          "
          class="d-flex flew-column justify-end pa-0"
        >
          <v-switch v-model="refundTransport" hide-details="auto" class="ma-0 pa-0" />
          <v-list-item-action-text v-if="isMobile" class="pt-1">
            {{ $t('return.refundTransport') }}
          </v-list-item-action-text>
          <span v-else>{{ $t('return.refundTransport') }}</span>
        </v-col>
        <v-col
          v-if="
            ['products_received', 'products_partially_received'].includes(returnOrder.current_status) &&
            chargeReturnFees.display_button &&
            ((chargeReturnFees.available && this.chargeReturnFees.prepaid_return_label) ||
              returnOrder.return_fees_amount)
          "
          class="d-flex flew-column justify-end px-0 pb-0"
        >
          <v-switch v-model="returnFeesDeducted" hide-details="auto" class="ma-0 pa-0" />
          <v-list-item-action-text v-if="isMobile" class="pt-1">
            {{ $t('return.settings.charge_return_fees.customerChargeReturnFees') }}
          </v-list-item-action-text>
          <span v-else>{{ $t('return.settings.charge_return_fees.customerChargeReturnFees') }}</span>
        </v-col>
        <v-row
          v-if="
            (['waiting_products_receipt'].includes(returnOrder.current_status) &&
              newRefundAmount != returnOrder.amount) ||
            ['products_received', 'products_partially_received'].includes(returnOrder.current_status)
          "
        >
          <v-col class="d-flex flew-column justify-end">
            <v-simple-table dense id="summary-table">
              <tbody>
                <tr>
                  <td class="mid-row"></td>
                  <td class="mid-row text-right pl-0 pr-1">
                    <v-list-item-action-text v-if="isMobile">{{ $t('return.productsTotal') }}:</v-list-item-action-text>
                    <span v-else>{{ $t('return.productsTotal') }}</span>
                    :
                  </td>
                  <td class="mid-row text-right pl-0">
                    <v-list-item-action-text v-if="isMobile">
                      {{ convertPrice(totalSelectedProducts, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </v-list-item-action-text>
                    <span v-else>
                      {{ convertPrice(totalSelectedProducts, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </span>
                  </td>
                </tr>
                <tr v-if="newRefundAmount && transportRefundAmount && refundTransport">
                  <td :class="returnOrder.return_fees_amount ? 'mid-row text-right' : 'text-right'">
                    <v-icon x-small>mdi-plus</v-icon>
                  </td>
                  <td :class="returnOrder.return_fees_amount ? 'mid-row text-right pl-0 pr-1' : 'text-right pl-0 pr-1'">
                    <v-list-item-action-text v-if="isMobile">
                      {{ $t('return.transportCosts') }}:
                    </v-list-item-action-text>
                    <span v-else>{{ $t('return.transportCosts') }}:</span>
                  </td>
                  <td :class="returnOrder.return_fees_amount ? 'mid-row text-right pl-0' : 'text-right pl-0'">
                    <v-list-item-action-text v-if="isMobile">
                      {{ convertPrice(transportRefundAmount, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </v-list-item-action-text>
                    <span v-else>
                      {{ convertPrice(transportRefundAmount, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </span>
                  </td>
                </tr>
                <tr v-if="returnFeesAmountToDeduct && returnFeesDeducted">
                  <td class="text-right">
                    <v-icon x-small>mdi-minus</v-icon>
                  </td>
                  <td class="text-right pl-0 pr-1">
                    <v-list-item-action-text v-if="isMobile">{{ $t('return.returnFees') }}:</v-list-item-action-text>
                    <span v-else>{{ $t('return.returnFees') }}:</span>
                  </td>
                  <td class="text-right pl-0">
                    <v-list-item-action-text v-if="isMobile">
                      {{ convertPrice(returnFeesAmountToDeduct, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </v-list-item-action-text>
                    <span v-else>
                      {{ convertPrice(returnFeesAmountToDeduct, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="total-row"></td>
                  <td class="text-right pl-0 pr-1 total-row">
                    <v-list-item-action-text v-if="isMobile">
                      {{ $t('return.newRefundAmount') }}:
                    </v-list-item-action-text>
                    <span v-else>{{ $t('return.refundAmount') }}:</span>
                  </td>
                  <td class="text-right pl-0 total-row">
                    <v-list-item-action-text v-if="isMobile">
                      {{ convertPrice(newRefundAmount, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </v-list-item-action-text>
                    <span v-else>
                      {{ convertPrice(newRefundAmount, returnOrder.currency).toFixed(2) }}
                      {{ returnOrder.currency ? returnOrder.currency.code : returnOrder.currency_code }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-col>
          <v-row
            justify="center mb-2"
            v-if="
              !returnOrder.origin_location_id &&
              !['cancelled', 'waiting'].includes(returnOrder.current_status) &&
              displayReturnLabelButton
            "
          >
            <div class="text-center">
              <v-btn :loading="loadingReturnLabel" @click="getReturnLabel()" dark depressed tile>
                {{ $t('return.printReturnLabel') }}
                <v-icon right dark>mdi-cloud-print-outline</v-icon>
              </v-btn>
            </div>
          </v-row>
          <v-row v-if="!['cancelled', 'finished'].includes(returnOrder.current_status)" justify="center">
            <v-col>
              <v-row justify="center" class="mb-2">
                <v-btn
                  v-if="
                    refundOnTerminal &&
                    (newRefundAmount || refundTransport) &&
                    ['products_partially_received', 'products_received'].includes(this.returnOrder.current_status)
                  "
                  :large="$vuetify.breakpoint.width >= 660"
                  :medium="$vuetify.breakpoint.width < 660"
                  color="primary"
                  depressed
                  tile
                  :disabled="cancellation || loadingBtn || missingReturnedQuantity || missingNonRefundReason"
                  :loading="loadingBtn"
                  @click="openTerminalDialog()"
                  style="max-width: 95%"
                >
                  {{ $t('return.terminalRefund') }}
                </v-btn>
                <v-btn
                  v-else
                  :large="$vuetify.breakpoint.width >= 660"
                  :medium="$vuetify.breakpoint.width < 660"
                  color="primary"
                  depressed
                  tile
                  :disabled="cancellation || loadingBtn || missingReturnedQuantity || missingNonRefundReason"
                  :loading="loadingBtn"
                  @click="update(returnOrder.current_status)"
                  style="max-width: 95%"
                >
                  {{ getConfirmStatusTranslation(returnOrder.current_status) }}
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn
                  :large="$vuetify.breakpoint.width >= 660"
                  :medium="$vuetify.breakpoint.width < 660"
                  :loading="cancellation"
                  :disabled="cancellation || loadingBtn"
                  color="secondary"
                  outlined
                  tile
                  @click="cancelReturnDialog = true"
                >
                  {{ $t('return.cancelReturn') }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <customer-details-bar
          v-if="mustDisplayCustomerInformation"
          class="mt-2"
          :customer="returnOrder.customer"
          :pickingAddress="returnOrder.picking_address"
        ></customer-details-bar>
      </v-container>
    </v-card>
    <order-status-history-dialog v-model="showHistoryDialog" @close="closeHistoryDialog()" :item="targetItem" />
    <return-cancel-dialog
      v-model="cancelReturnDialog"
      :reasons="cancelReasons"
      :cancel-after-receipt="cancelAfterReceipt"
      :after-receipt="isAfterReceipt"
      @confirm="cancel"
    />
    <confirmation-refund-dialog
      v-model="showConfirmRefundDialog"
      :currency="returnOrder.currency"
      :refund="newRefundAmount"
      @validate="validateConfirmationRefundDialog"
      @close="closeConfirmationRefundDialog"
    />
    <barcode-type-dialog
      :title="$t('product.enterYourBarcode')"
      v-model="showBarcodeDialog"
      @validate="validateBarcodeDialog"
      @close="addEventKeyDown"
    />
    <terminal-selection-dialog
      v-if="showTerminalDialog"
      v-model="showTerminalDialog"
      @closeTerminalDialog="closeTerminalDialog"
      @refund="refund"
      :testMode="testMode"
      :currentStore="currentStoreDetails"
    />
    <payment-status-dialog
      v-if="showPaymentStatusDialog"
      v-model="showPaymentStatusDialog"
      :refund-status="refundStatus"
      @closePaymentStatusDialog="showPaymentStatusDialog = false"
      @openTerminalDialog="openTerminalDialog"
      @manualValidation="manualValidation"
      @cancelRefund="cancelRefund"
    />
    <spread-item-scan-dialog
      v-model="spreadItemScanDialog"
      :title="$t('product.customVariant')"
      :introductionSentence="$t('product.customReturnVariantText')"
    ></spread-item-scan-dialog>
  </v-container>
</template>
<script>
  import ConfirmationRefundDialog from '@/components/dialogs/ConfirmationRefundDialog.vue'
  import OrderStatusHistoryDialog from '@/components/dialogs/StatusHistoryDialog.vue'
  import ReturnCancelDialog from '@/components/returns/ReturnCancelDialog.vue'
  import CustomerDetailsBar from '@/components/CustomerDetailsBar'
  import { EventBus } from '../../event-bus'
  import { mapState } from 'vuex'
  import ReturnHeadersMobile from '@/components/returns/ReturnHeadersMobile.vue'
  import ReturnHeaders from '@/components/returns/ReturnHeaders.vue'
  import ProductListMobile from '@/components/returns/products/ProductListMobile.vue'
  import ProductList from '@/components/returns/products/ProductList.vue'
  import SimpleTextInputDialog from '@/components/dialogs/SimpleTextInputDialog'
  import TerminalSelectionDialog from '@/components/payment/TerminalSelectionDialog'
  import PaymentStatusDialog from '@/components/payment/PaymentStatusDialog'
  import informationDialog from '@/components/dialogs/InformationDialog'
  import moment from 'moment'

  export default {
    name: 'ReturnDetail',
    components: {
      OrderStatusHistoryDialog,
      ReturnCancelDialog,
      ConfirmationRefundDialog,
      CustomerDetailsBar,
      ReturnHeadersMobile,
      ReturnHeaders,
      ProductList,
      ProductListMobile,
      barcodeTypeDialog: SimpleTextInputDialog,
      TerminalSelectionDialog,
      PaymentStatusDialog,
      spreadItemScanDialog: informationDialog,
    },
    data() {
      return {
        showHistoryDialog: false,
        showConfirmRefundDialog: false,
        targetItem: undefined,
        cancelReturnDialog: false,
        validateRefund: false,
        cancellation: false,
        loadingBtn: false,
        returnOrder: undefined,
        defaultImage: require('@/assets/img/products/product_default.png'),
        scan: '',
        showBarcodeDialog: false,
        refundTransport: false,
        showTerminalDialog: false,
        refundOnTerminal: false,
        testMode: false,
        pollJob: null,
        showPaymentStatusDialog: false,
        refundStatus: 'processing',
        loadingReturnSetting: false,
        loadingReturnLabel: false,
        spreadItemScanDialog: false,
        displayReturnLabelButton: false,
        refundCarrierCost: {},
        chargeReturnFees: {},
        returnFeesDeducted: false,
        sendReturnReference: null,
        cancelReasons: [],
        itemNonRefundReasons: [],
        cancelAfterReceipt: {},
      }
    },
    mounted() {
      this.get()
    },
    deactivated() {
      clearInterval(this.pollJob)
    },
    beforeDestroy() {
      this.removeEventKeyDown()
    },
    methods: {
      getConfirmStatusTranslation(confirmStatusValue) {
        let confirmStatus = this.confirmStatus.find((confirmStatus) => confirmStatus.value == confirmStatusValue)
        if (confirmStatus) {
          return confirmStatus.text
        } else return confirmStatusValue
      },
      getCancelReasonTranslation(cancelReasonValue) {
        var cancelReason = this.cancelReasons.find((cancelReason) => cancelReason.value == cancelReasonValue)
        if (cancelReason) {
          return cancelReason.text
        } else return cancelReasonValue
      },
      cancel({ reason, restoreItems }) {
        this.update('cancelled', reason, restoreItems)
      },
      openConfirmationRefundDialog() {
        this.showConfirmRefundDialog = true
      },
      validateConfirmationRefundDialog() {
        this.validateRefund = true
        this.update('finished')
      },
      closeConfirmationRefundDialog() {
        this.validateRefund = false
        this.showConfirmRefundDialog = false
      },
      update(changeStatus, cancelReason = undefined, restoreItems = undefined) {
        let returnCopy = JSON.parse(JSON.stringify(this.returnOrder))
        if (this.returnOrder.current_status === 'waiting') {
          for (let item of returnCopy.items) {
            if (changeStatus !== 'cancelled' && this.approvedAmount !== 0) {
              // we set return_quantity with item.approved_quantity but not when it will result a cancellation, to keep track of original return quantities
              item.return_quantity = item.approved_quantity
            }
          }
          // if status is already cancelled, it means that it results from seller pushing the cancel button and not from all approved_quantity to 0
          // so we don't want to use a wrong approvedAmount for the following operations
          if (changeStatus !== 'cancelled') {
            if (this.approvedAmount === 0) {
              changeStatus = 'cancelled'
              cancelReason = 'no_product_approved'
            } else {
              returnCopy.amount = this.approvedAmount
              if (this.returnOrder.transport_refund_amount && this.refundTransport) {
                returnCopy.amount += this.returnOrder.transport_refund_amount
              }
            }
          }
        }
        if (changeStatus === 'cancelled') {
          this.cancellation = true
          returnCopy.cancel_reason = cancelReason
          if (restoreItems !== undefined) {
            returnCopy.restore_items = restoreItems
          }
        } else {
          this.loadingBtn = true
        }

        if (changeStatus === 'finished' || changeStatus === 'cancelled') {
          returnCopy.current_status = changeStatus
          if (changeStatus === 'finished') {
            returnCopy.return_fees_amount = this.returnFeesAmountToDeduct
            for (let item of returnCopy.items) {
              if (item.returned_quantity === item.refunded_quantity && item.returned_quantity != 0) {
                item.non_refund_reason = undefined
              }
            }
          }
        } else {
          let index = this.status.findIndex((status) => status.value === changeStatus)

          if (index + 1 < this.status.length - 1) {
            if (this.status[index + 1].value === 'finished' || this.status[index + 2].value === 'finished') {
              this.openConfirmationRefundDialog()
              this.loadingBtn = false
              return
            }
            returnCopy.current_status = ['products_partially_received', 'products_received'].includes(
              this.returnOrder.current_status
            )
              ? 'finished'
              : this.status[index + 1].value
          }
        }
        if (
          ['waiting_products_receipt', 'products_partially_received', 'products_received'].includes(
            this.returnOrder.current_status
          )
        ) {
          returnCopy.refunded_amount = this.newRefundAmount
        }
        if (!this.refundTransport && this.returnOrder.transport_refund_amount) {
          returnCopy.transport_refund_amount = null
        } else if (this.refundTransport && this.transportRefundAmount) {
          returnCopy.transport_refund_amount = this.transportRefundAmount
        }

        let path = '/v1/int/returns/' + this.$route.params.id
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: returnCopy,
        }
        this.$Amplify.API.put('returns', path, myInit)
          .then((res) => {
            if (['products_received', 'products_partially_received'].includes(res.current_status)) {
              for (let item of res.items) {
                if (!item.refunded_quantity) {
                  item.refunded_quantity = item.returned_quantity
                  item.non_refund_reason = !item.returned_quantity ? 'products_not_received' : undefined
                }
              }
            }
            this.returnOrder = res
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('return.returnUpdated'),
              color: 'success',
            })
            this.loadingBtn = false
            this.cancellation = false

            if (this.returnOrder.current_status == 'finished') {
              this.$router.push('/returns')
            }
          })
          .catch((e) => {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('return.errorUpdatingReturn'),
              color: 'error',
            })
            console.log(e)
            this.loadingBtn = false
            this.cancellation = false
            return false
          })
      },
      get: function () {
        let path = '/v1/int/returns/' + this.$route.params.id
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {},
        }
        if (!this.isCustomerService) {
          myInit.queryStringParameters.originLocationId = this.currentStore
        }
        this.$Amplify.API.get('returns', path, myInit)
          .then((res) => {
            if (['products_received', 'products_partially_received'].includes(res.current_status)) {
              for (let item of res.items) {
                if (!item.refunded_quantity) {
                  item.refunded_quantity = item.returned_quantity
                  item.non_refund_reason = !item.returned_quantity ? 'products_not_received' : undefined
                }
              }
            } else if ('waiting' === res.current_status) {
              for (let item of res.items) {
                if (!item.refunded_quantity) {
                  item.approved_quantity = item.return_quantity
                }
              }
            }
            if (res.transport_refund_amount) {
              this.refundTransport = true
            }
            if (res.return_fees_amount) {
              this.returnFeesDeducted = true
            }
            this.returnOrder = res
            this.getReturnSettings()
            this.loadingBtn = false
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('return.errorLoadingReturn'),
              color: 'error',
            })
          })
      },
      openBarcodeDialog() {
        //open barcode dialog to manually insert barcode
        this.removeEventKeyDown()
        this.showBarcodeDialog = true
      },
      validateBarcodeDialog: function (ean) {
        this.addEventKeyDown()
        this.checkItemsForScan(ean)
      },
      checkItemsForScan(value) {
        // check items if product_ean equals to ean scan
        for (let item of this.returnOrder.items) {
          let barcode = item.product_ean || item.barcode
          if (barcode == value) {
            if (this.getItemOccurrences(barcode) > 1) {
              this.spreadItemScanDialog = true
              return
            }
            if (!item.returned_quantity) {
              this.$set(item, 'returned_quantity', 0)
              item.returned_quantity = 0
            }
            if (item.returned_quantity < item.return_quantity) {
              item.returned_quantity++
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('product.productScanned'),
                color: 'success',
              })
              this.showBarcodeDialog = false
              return
            } else {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('product.productAlreadyScanned'),
                color: 'error',
              })
              return
            }
          }
        }
        EventBus.$emit('displaySnackbar', {
          display: true,
          text: this.$t('product.productScannedError'),
          color: 'error',
        })
      },
      addEventKeyDown() {
        // add event to scan a product
        document.addEventListener('keydown', this.convertSpecialCharToNumber)
      },
      removeEventKeyDown() {
        // remove the event
        document.removeEventListener('keydown', this.convertSpecialCharToNumber)
      },
      convertSpecialCharToNumber(event) {
        // convert the caracts getted from scan and store it to scan data then compare ean
        var charCode = event.charCode ? event.charCode : event.keyCode
        if (charCode >= 48 && charCode <= 57) {
          this.scan += String.fromCharCode(charCode)
        } else if (charCode == 13 && this.scan.trim() != '') {
          this.checkItemsForScan(this.scan)
          this.scan = ''
        }
      },
      convertPrice(value, currency) {
        const priceMultiplier = currency ? Math.pow(10, currency.minor_unit) : 100
        return value / priceMultiplier
      },
      getReturnSettings() {
        this.loadingReturnSetting = true
        let filters = {
          default_settings: true,
        }
        // The API applies cancel_after_receipt from the delivery country, not from the store's one.
        // The other settings still follow the store's country until that rule is decided for them.
        const deliveryCountryCode = this.returnOrder.shipping_address?.country_code
        const countries = []
        if (this.currentStoreDetails) {
          countries.push(this.currentStoreDetails.address.country_id)
        }
        if (deliveryCountryCode && !countries.includes(deliveryCountryCode)) {
          countries.push(deliveryCountryCode)
        }
        if (countries.length) {
          filters.countries = countries
        }
        const myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            filters: JSON.stringify(filters),
          },
        }
        this.$Amplify.API.get('returns', '/v1/int/settings', myInit).then((res) => {
          const defaultSettings = res.data.find((item) => item.default_settings === true)
          let settings
          if (this.currentStoreDetails) {
            let countryCode = this.currentStoreDetails.address.country_id
            settings = res.data.find((item) => item.country_code === countryCode)
          }
          if (!settings) {
            settings = defaultSettings
          }
          // Same fallback as the API: the delivery country's document, else the default one.
          const deliverySettings =
            (deliveryCountryCode && res.data.find((item) => item.country_code === deliveryCountryCode)) ||
            defaultSettings

          this.refundOnTerminal = settings?.refund_on_terminal ? settings.refund_on_terminal.activate : false
          this.testMode = settings?.refund_on_terminal ? settings.refund_on_terminal.activate_test_mode : false
          this.displayReturnLabelButton = settings?.display ? settings.display.return_label_button : false
          this.refundCarrierCost = settings?.refund_order_carrier_cost ? settings.refund_order_carrier_cost : {}
          this.chargeReturnFees = settings?.charge_return_fees ? settings.charge_return_fees : {}
          this.sendReturnReference = settings?.refund_on_terminal.send_return_reference
          this.itemNonRefundReasons = settings?.display?.item_non_refund_reasons
          this.cancelAfterReceipt = deliverySettings?.cancel_after_receipt || {}
          this.setCancelReasons(settings)
          this.loadingReturnSetting = false
        })
      },
      openTerminalDialog() {
        this.showTerminalDialog = true
        this.showPaymentStatusDialog = false
        this.refundStatus = 'processing'
      },
      closeTerminalDialog() {
        this.showTerminalDialog = false
      },
      refund({ selectedTerminal, refundTypeTest }) {
        this.showTerminalDialog = false
        this.showPaymentStatusDialog = true
        let reference
        if (this.sendReturnReference) {
          const date = moment.utc().format('YYMMDDHHMMSS')
          reference = `${this.returnOrder.return_id}-${date}`
        }
        const myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: {
            terminal_id: selectedTerminal,
            amount: this.newRefundAmount,
            return_id: this.returnOrder.return_id,
            currency: this.returnOrder.currency.code,
            refund: true,
            reference,
          },
        }
        if (!this.testMode) {
          this.$Amplify.API.post('payment', '/payments', myInit)
            .then((res) => {
              if (res && res.reference && res.status === 'processing') {
                this.pollJob = setInterval(() => {
                  this.$Amplify.API.get('payment', '/payments/' + res.reference, {
                    headers: {
                      Authorization: 'Bearer ' + this.$auth.accessToken,
                    },
                  })
                    .then((res) => {
                      let success = res.status === 'success'
                      this.refundStatus = res.status
                      if (success) {
                        clearInterval(this.pollJob)
                        this.update('finished')
                      } else if (res.status === 'error') {
                        clearInterval(this.pollJob)
                      }
                    })
                    .catch((error) => {
                      console.log(error)
                      clearInterval(this.pollJob)
                      EventBus.$emit('displaySnackbar', {
                        display: true,
                        text: this.$t('refund.jobLoadingErrorMessage'),
                        color: 'error',
                      })
                      this.refundStatus = 'error'
                    })
                }, 5000)
              } else {
                EventBus.$emit('displaySnackbar', {
                  display: true,
                  text: this.$t('refund.jobLoadingErrorMessage'),
                  color: 'error',
                })
                this.refundStatus = 'error'
              }
            })
            .catch((error) => {
              console.log(error)
              this.refundStatus = 'error'
            })
        } else {
          this.pollJob = setInterval(() => {
            if (refundTypeTest === 'success') {
              this.update('finished')
            }
            this.refundStatus = refundTypeTest
            clearInterval(this.pollJob)
          }, 10000)
        }
      },
      manualValidation() {
        clearInterval(this.pollJob)
        this.update('finished')
        EventBus.$emit('displaySnackbar', {
          color: 'success',
          text: this.$t('refund.manualSuccess'),
          display: true,
        })
      },
      cancelRefund() {
        clearInterval(this.pollJob)
        EventBus.$emit('displaySnackbar', {
          color: 'success',
          text: this.$t('refund.cancelSuccess'),
          display: true,
        })
      },
      getReturnLabel: function () {
        let path = `/v1/int/returns/${this.returnOrder.return_id}/labels`
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        this.loadingReturnLabel = true
        this.$Amplify.API.post('returns', path, myInit)
          .then((res) => {
            const link = document.createElement('a')
            link.href = res.fileLocation
            if (!this.isMobile) {
              link.target = '_blank'
            }
            document.body.appendChild(link)
            link.click()
            this.loadingReturnLabel = false
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              color: 'error',
              text:
                e.response.status === 404
                  ? this.$t('subOrder.shippingLabelNotFound')
                  : 'Error during generating slip order',
            })
            this.loadingReturnLabel = false
          })
      },
      getItemOccurrences(barcode) {
        return this.returnOrder.items.reduce((accumulator, currentValue) => {
          if (barcode == currentValue.barcode) {
            return accumulator + 1
          } else {
            return accumulator
          }
        }, 0)
      },
      setCancelReasons(settings) {
        let cancelReasonsTranslations = [
          { text: this.$t('return.clientChangeOfMind'), value: 'client_changed_his_mind' },
          { text: this.$t('return.deterioratedProducts'), value: 'deteriorated_products' },
          { text: this.$t('return.missingProduct'), value: 'missing_product' },
        ]
        if (Array.isArray(settings?.display?.return_cancel_reasons)) {
          this.cancelReasons = []
          for (const returnCancelReason of settings.display.return_cancel_reasons) {
            const translatedCancelReason = cancelReasonsTranslations.find((translatedCancelReason) => {
              return returnCancelReason === translatedCancelReason.value
            })
            if (translatedCancelReason) {
              this.cancelReasons.push(translatedCancelReason)
            } else {
              this.cancelReasons.push({ text: returnCancelReason, value: returnCancelReason })
            }
          }
        } else {
          this.cancelReasons = cancelReasonsTranslations
        }
        this.cancelReasons.push({ text: this.$t('return.otherReason'), value: 'other' })
      },
    },
    computed: {
      ...mapState(['currentStore', 'isCustomerService', 'currentStoreDetails']),
      // Rule: no modal changes at all for a cancellation before the receipt is validated, whatever the setting.
      isAfterReceipt() {
        return !['waiting', 'waiting_products_receipt'].includes(this.returnOrder.current_status)
      },
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      missingReturnedQuantity() {
        if (this.returnOrder.current_status === 'waiting_products_receipt') {
          let missingReturnedQuantity = false
          if (this.returnOrder && this.returnOrder.items) {
            for (const item of this.returnOrder.items) {
              if (item.returned_quantity === undefined) {
                missingReturnedQuantity = true
                break
              }
            }
          }
          return missingReturnedQuantity
        } else {
          return false
        }
      },
      isScanStep() {
        if (this.returnOrder.current_status === 'waiting_products_receipt') {
          this.addEventKeyDown()
        }
        return this.returnOrder.current_status === 'waiting_products_receipt'
      },
      totalSelectedProducts() {
        let receivedProductsAmount = 0
        if (this.returnOrder.current_status === 'waiting_products_receipt') {
          for (const item of this.returnOrder.items) {
            if (item.returned_quantity) {
              receivedProductsAmount += item.returned_quantity * item.product_sale_price
            }
          }
        } else if (['products_received', 'products_partially_received'].includes(this.returnOrder.current_status)) {
          for (const item of this.returnOrder.items) {
            if (item.refunded_quantity) {
              receivedProductsAmount += item.refunded_quantity * item.product_sale_price
            }
          }
        }
        return receivedProductsAmount
      },
      newRefundAmount() {
        if (
          ['waiting_products_receipt', 'products_received', 'products_partially_received'].includes(
            this.returnOrder.current_status
          )
        ) {
          let receivedProductsAmount = this.totalSelectedProducts
          if (receivedProductsAmount) {
            if (this.transportRefundAmount && /*receivedProductsAmount != 0 ||*/ this.refundTransport) {
              receivedProductsAmount += this.transportRefundAmount
            }
          }
          if (this.returnFeesDeducted) {
            receivedProductsAmount -= this.returnFeesAmountToDeduct
          }
          return receivedProductsAmount > 0 ? receivedProductsAmount : 0
        } else {
          return this.returnOrder.amount
        }
      },
      returnFeesAmountToDeduct() {
        let returnFeesAmountToDeduct = 0
        if (this.returnFeesDeducted) {
          if (this.returnOrder.return_fees_amount) {
            returnFeesAmountToDeduct = this.returnOrder.return_fees_amount
          } else if (
            this.chargeReturnFees?.return_fees_amount &&
            this.chargeReturnFees.available &&
            this.chargeReturnFees.prepaid_return_label
          ) {
            returnFeesAmountToDeduct =
              this.chargeReturnFees.return_fees_amount *
              Math.pow(10, this.chargeReturnFees.return_fees_currency.minor_unit)
          }
        }
        return returnFeesAmountToDeduct
      },
      missingNonRefundReason() {
        if (['products_received', 'products_partially_received'].includes(this.returnOrder.current_status)) {
          let missingNonRefundReason = false
          if (this.returnOrder && this.returnOrder.items) {
            for (const item of this.returnOrder.items) {
              if (
                (item.refunded_quantity === 0 || item.refunded_quantity < item.returned_quantity) &&
                !item.non_refund_reason
              ) {
                missingNonRefundReason = true
                break
              }
            }
          }
          return missingNonRefundReason
        } else {
          return false
        }
      },
      status() {
        return [
          { text: this.$t('return.waiting'), value: 'waiting' },
          { text: this.$t('return.waitingProductsReceipt'), value: 'waiting_products_receipt' },
          { text: this.$t('return.productsReceived'), value: 'products_received' },
          { text: this.$t('return.productsPartiallyReceived'), value: 'products_partially_received' },
          { text: this.$t('return.finished'), value: 'finished' },
          { text: this.$t('return.cancelled'), value: 'cancelled' },
        ]
      },
      confirmStatus() {
        return [
          { text: this.$t('return.confirmReturn'), value: 'waiting' },
          { text: this.$t('return.confirmProductsReceived'), value: 'waiting_products_receipt' },
          { text: this.$t('return.finished'), value: 'products_partially_received' },
          { text: this.$t('return.finished'), value: 'products_received' },
        ]
      },
      mustDisplayCustomerInformation() {
        let displayCustomerInformation = true
        if (
          !this.returnOrder.billing_address &&
          !this.returnOrder.shipping_address &&
          !this.returnOrder.customer.email &&
          !this.returnOrder.customer.last_name &&
          !this.returnOrder.customer.first_name &&
          !this.returnOrder.customer.phone &&
          !this.returnOrder.customer.last_four_digit_phone_number
        ) {
          displayCustomerInformation = false
        }
        return displayCustomerInformation
      },
      transportAlreadyRefundedInAnotherReturn() {
        return (
          this.returnOrder.transport_refund_return_id &&
          this.returnOrder.transport_refund_return_id !== this.returnOrder.return_id
        )
      },
      transportRefundAmount() {
        return this.returnOrder.potential_transport_refund_amount ?? this.returnOrder.transport_refund_amount
      },
      approvedAmount() {
        if (this.returnOrder.current_status === 'waiting') {
          let approvedProductsAmount = 0
          for (const item of this.returnOrder.items) {
            if (item.approved_quantity) {
              approvedProductsAmount += item.approved_quantity * item.product_sale_price
            }
          }
          return approvedProductsAmount
        } else {
          return this.returnOrder.amount
        }
      },
    },
  }
</script>

<style scoped>
  button >>> .v-btn__content {
    width: 100%;
    white-space: normal;
  }
  .mid-row {
    border-bottom: none !important;
  }

  .total-row {
    border-top: thin solid hsla(0, 0%, 100%, 0.12) !important;
  }

  #summary-table tr:hover:not(.v-table__expanded__content) {
    background: transparent !important;
  }
</style>
